module.exports = __webpack_public_path__ + "static/media/1-en.b462d958.svg";